<template>
  <div class="page-box loan-detail">
    <div class="dtl-head">
      <!--面包屑导航-->
      <div class="pageTit c-breadcrumb">
        <el-breadcrumb separator=">" class="theme-default">
          <el-breadcrumb-item :to="{ path: menuMsg.path }">{{ menuMsg.name }}</el-breadcrumb-item>
          <el-breadcrumb-item>{{ $t('financingDetails.financingaplayBook') }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <!--流水号-->
      <p class="top-tit" style="text-align:right;padding-right:90px;width:unset"><span>{{ $t('loan.financingNum') }}：</span>
        <span>{{ f_n }}</span>
      </p>
      <!--分界线-->
      <img class="c-divider" src="../../../assets/images/common/documentSeparation.png" alt="">
    </div>

    <div class="main-box">
      <!--tab-->
      <div class="c-tab-tit">
        <span :class="index===0 ? 'active' : '' " @click="checkTab(0)">{{ $t('loan.cicContract') }}</span>
        <span :class="index===1 ? 'active' : '' " @click="checkTab(1)">{{ $t('loan.financingContract') }}</span>
        <span :class="index===2 ? 'active' : '' " @click="checkTab(2)">{{ $t('loan.applyBasicInfo') }}</span>
      </div>
      <div class="c-tab-body">
        <!--    CIC合同-->
        <div v-show="index===0" class="tab-item">
          <div class="box-item top mb_20">
            <z-collapse :title="$t('loan.contract')" :is-toggle="true">
              <div v-if="contract && contract.length>0" class="card-box">
                <div v-for="(item,index) in contract" :key="index" class="single-card">
                  <z-card :title="applyStatus[item.applyStatus]">
                    <ul class="card-list">
                      <li><span class="tit">{{ $t('loan.contractNo') }}</span><div class="msg">{{ item.contractNumber }}</div></li>
                      <!--              合同号-->
                      <li><span class="tit">{{ $t('loan.buyer') }}</span><div class="msg">{{ item.buyer }}</div></li>
                      <!--              买方-->
                      <li><span class="tit">{{ $t('loan.buyerCountry') }}</span><div class="msg">{{ item.buyerCountry }}</div></li>
                      <!--              买方所属国-->
                      <li><span class="tit">{{ $t('loan.seller') }}</span><div class="msg">{{ item.seller }}</div></li>
                      <!--              卖方-->
                      <li><span class="tit">{{ $t('loan.sellerCountry') }}</span><div class="msg">{{ item.sellerCountry }}</div></li>
                      <!--              买方所属国-->
                      <li><span class="tit">{{ $t('loan.goodsCategory') }}</span><div class="msg">{{ item.productType }}</div></li>
                      <!--              商品类别-->
                      <li><span class="tit">{{ $t('loan.goodsName') }}</span><div class="msg">{{ item.productName }}</div></li>
                      <!--              商品名称-->
                      <li><span class="tit">{{ $t('loan.contractNumber') }}</span><div class="msg">
                        {{ item.contractQuantity | formatNum }} {{ item.contractQuantityUnit }}&nbsp;( +{{ item.contractUpperLimit }}%-{{ item.contractLowerLimit }}% )
                      </div></li>
                      <!--              合同数量-->

                      <li><span class="tit">{{ $t('loan.unitPrice') }}</span><div class="msg">
                        {{ item.price }} {{ item.priceCurrency }}/{{ item.priceUnit }}
                      </div></li>
                      <!--              单价-->
                      <li><span class="tit">{{ $t('loan.packaging') }}</span><div class="msg">{{ item.pack }}</div></li>
                      <!--              包装-->
                      <li><span class="tit">{{ $t('loan.amount') }}</span><div class="msg">
                        {{ item.currency }} {{ item.money | formatNum }}&nbsp;( +{{ item.moneyUpperLimit }}%-{{ item.moneyLowerLimit }}% )
                      </div></li>
                      <!--              金额-->

                      <li><span class="tit">{{ $t('loan.paymentWay') }}</span><div class="msg">{{ item.rpaymentMethod }}</div></li>
                      <!--              付款方式-->
                      <li><span class="tit">{{ $t('loan.paymentDays') }}</span><div class="msg">{{ item.paymentDays }}</div></li>
                      <!--              账期-->
                      <li><span class="tit">{{ $t('loan.tradeTerms') }}</span><div class="msg">{{ item.tradeTerms }}</div></li>
                      <!--              贸易条款-->
                      <li><span class="tit">{{ $t('loan.shipmentDate') }}</span><div class="msg">{{ item.esTimeShip }}</div></li>
                      <!--              装船日期-->
                      <li><span class="tit">{{ $t('loan.loadingPort') }}</span><div class="msg">{{ item.loadPort }}</div></li>
                      <!--              装货港-->
                      <li><span class="tit">{{ $t('loan.dischargePort') }}</span><div class="msg">{{ item.dischargePort }}</div></li>
                      <!--              卸货港-->
                      <li><span class="tit">{{ $t('loan.originCountry') }}</span><div class="msg">{{ item.countryOfOrigin }}</div></li>
                      <!--              原产国-->
                      <li><span class="tit">{{ $t('loan.tradeContract') }}</span>
                        <div v-if="item.transactionContractFileList && item.transactionContractFileList.length>0" class="msg c-file-list">
                          <a v-for="(fileObj,fileIndex) in item.transactionContractFileList" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                            <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                          </a>
                        </div>
                      </li>
                      <!--交易合同-->
                    </ul>
                  </z-card>
                </div>
                <!--采购合同、销售合同、终端合同-->
              </div>
            </z-collapse>
          </div>
          <!--    合同-->

          <div v-if="addFileList && addFileList.length > 0" class="box-item">
            <z-collapse :title="$t('loan.addFile')" :is-toggle="true" :is-hide="true">
              <!--              <div class="c-list-bg no-pt">-->
              <ul class="c-list border mt_15">
                <li class="w-100"><span class="tit">{{ $t('loan.addFile') }}：</span><div class="msg c-file-list">
                  <a v-for="(fileObj,fileIndex) in addFileList" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                    <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                  </a>
                </div></li>
              </ul>
              <div class="pb-20"/>
              <!--              </div>-->
            </z-collapse>
          </div>
          <!--    补充资料-->

          <div v-if="tradeLog.length>0" class="box-item">
            <z-collapse :title="$t('loan.tradeContractRecord')" :is-toggle="true" :is-hide="true">
              <el-table :data="tradeLog.slice((tradePage.pageNo-1)*pageSize, tradePage.pageNo*pageSize)" :class="tradePage.total>5? '':'pb-20'" class="dtl-tb">
                <el-table-column :label="$t('loan.auditConclusion')" prop="auditOpinion" width="700"/>
                <el-table-column :label="$t('loan.auditName')" prop="auditName" width="140"/>
                <el-table-column :label="$t('loan.date')" width="180">
                  <template slot-scope="scope">{{ scope.row.createTime | dateTimeConvert }}</template>
                </el-table-column>
              </el-table>
              <el-pagination
                v-show="tradePage.total>5"
                :total="tradePage.total"
                :page-size="pageSize"
                :current-page.sync="tradePage.pageNo"
                class="page-theme text-center pb_25"
                background
                layout="prev, pager, next"/>
            </z-collapse>
          </div>
          <!--    贸易合同审核记录-->

          <!--          <div class="loan-box">-->
          <!--          </div>-->
          <!-- v-show="hideStatus.indexOf(item.applicationStatus)<0" -->
          <div v-for="(v,i) in zmaCredit.filter(s=>s.loanStatus!=100&&s.loanStatus!=101&&s.loanStatus!=1001&&s.loanStatus!=1002)" v-show="v.show" :key="i+'z'" class="box-item loan-list">
            <!-- <span onselectstart="return false" @click="loanToggle(v)"><i :class="v.show ? 'el-icon-arrow-up': 'el-icon-arrow-down'" class="iconfont"/></span> -->
            <h3 :id="'#anchor_'+i" class="loan-tit">{{ 'NO.'+ v.serialNumber+' ' +loanTypeText[loanType] }} </h3>
            <!-- zmaShow[i] -->
            <div v-show="v.show" ref="loanform">
              <template v-if="loanType!=2">
                <p class="zma-status">
                  <span v-for="(subItem,subIndex) in loanStatusList" :class="getLoanStatus(v.loanStatus) === subIndex?'cur':''" :key="subIndex">{{ subItem }}</span>
                </p>
                <z-collapse v-if="v.zmaAuditLogs.length > 0" :title="'NO.'+ v.serialNumber +' ' + $t('loan.loanAuditRecord')" :is-toggle="true" :is-hide="false">
                  <el-table :data="v.zmaAuditLogs.slice((pagingParm.pageNo-1)*pageSize, pagingParm.pageNo*pageSize)" class="dtl-tb">
                    <el-table-column :label="$t('loan.auditConclusion')" prop="auditOpinion" width="700"/>
                    <el-table-column :label="$t('loan.auditName')" prop="auditName" width="140"/>
                    <el-table-column :label="$t('loan.date')" width="180">
                      <template slot-scope="scope">{{ scope.row.createTime | dateTimeConvert }}</template>
                    </el-table-column>
                  </el-table>
                  <el-pagination
                    v-show="v.zmaAuditLogs.length>5"
                    :total="v.zmaAuditLogs.length"
                    :page-size="pageSize"
                    :current-page.sync="pagingParm.pageNo"
                    class="page-theme text-center pb_25"
                    background
                    layout="prev, pager, next"/>
                </z-collapse>
                <z-collapse v-if="v.cicFsDepositInfoList && v.cicFsDepositInfoList.length > 0" :title="$t('newrisk.p_depositInfo')+`(${v.isInv==1?$t('newrisk.has_inv'):$t('newrisk.no_inv')})`" :is-toggle="true">
                  <div class="card-box">
                    <div v-for="(subItem,subIndex) in v.cicFsDepositInfoList" :key="subIndex" class="single-card">
                      <z-card :title="applyStatus[subItem.depositType]">
                        <ul v-if="subItem.depositType==1" class="card-list">
                          <!-- <li><span class="tit">{{ $t('loan.depositAttr') }}</span><div class="msg">{{ subItem.depositAtt == 2 ? $t('loan.depositAttr2'):$t('loan.depositAttr1') }}</div></li> -->
                          <li><span class="tit">{{ v.isInv==1? $t('newrisk.advance_amount'):$t('newrisk.advance_open_amount') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                          <li v-if="v.isInv==1"><span class="tit">{{ $t('newrisk.p_invoiceNo') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                          <li><span class="tit">{{ v.isInv==1? $t('loan.paymentDate'):$t('newrisk.p_open_date') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                          <li v-if="v.isInv!=1"><span class="tit">{{ $t('newrisk.p_open_bank') }}</span><div class="msg">{{ subItem.lssuing }}</div></li> <!--开证行-->
                          <li v-if="v.isInv==1"><span class="tit">{{ $t('loan.fileUpload') }}</span>
                            <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                              <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                              </a>
                            </div>
                          </li>
                        </ul>
                        <ul v-if="subItem.depositType==2" class="card-list">
                          <div class="type">{{ subItem.contractType?$t('newrisk.deposit_row_8'):$t('forfait.deposit_1') }}</div>
                          <template v-if="subItem.contractType">
                            <li><span class="tit">{{ v.isInv==1? $t('newrisk.deposit_row_1'):$t('newrisk.deposit_row_2') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                            <li><span class="tit" >{{ $t('newrisk.deposit_row_2') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                            <li><span class="tit">{{ v.isInv==1? $t('newrisk.deposit_row_4'):$t('newrisk.deposit_row_5') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                            <li><span class="tit" >{{ v.isInv==1? $t('newrisk.deposit_row_6'):$t('newrisk.deposit_row_7') }}</span><div class="msg">{{ subItem.lssuing }}</div></li> <!--开证行-->
                            <li><span class="tit" >{{ $t('loan.fileUpload') }}</span>
                              <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                                <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                  <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                                </a>
                              </div>
                            </li>
                          </template>
                          <template v-else>
                            <li><span class="tit">{{ $t('loan.depositAmount') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                            <li><span class="tit">{{ $t('loan.invoiceNo') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                            <li><span class="tit">{{ $t('baseInfo.paymentDate') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                            <li><span class="tit">{{ $t('loan.fileUpload') }}</span>
                              <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                                <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                  <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                                </a>
                              </div>
                            </li>
                          </template>
                        </ul>
                        <ul v-if="subItem.depositType==3" class="card-list">
                          <li><span class="tit">{{ $t('loan.depositAmount') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                          <li><span class="tit">{{ $t('loan.invoiceNo') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                          <li><span class="tit">{{ $t('baseInfo.paymentDate') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                          <li><span class="tit">{{ $t('loan.fileUpload') }}</span>
                            <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                              <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                              </a>
                            </div>
                          </li>
                        </ul>
                      </z-card>
                    </div>
                    <!--采购合同、销售合同、终端合同-->

                  </div>
                </z-collapse>
                <!--    定金资料-->

                <!-- <div :id="getCurStatus(v.loanStatus) === 1 ? '#anchorAction_'+index :''"/> -->
                <forfait-msg ref="forfaitMsgOut" @submit="forfaitSubmit"/>
                <!--      福费廷协议  -->

                <z-collapse v-if="v.zmaWaterFileS && v.zmaWaterFileS.length>0&&v.loanStatus!=1007&&v.loanStatus!=1008" :title="$t('loan.loanWater')" :is-toggle="true" class="divider mb_20">
                  <ul class="c-list border mt_15">
                    <li class="w-100"><span class="tit">{{ $t('loan.fileUpload') }}：</span><div class="msg c-file-list">
                      <a v-for="(fileObj,fileIndex) in v.zmaWaterFileS" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                        <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                      </a>
                    </div></li>
                  </ul>
                </z-collapse>
                <!--       放款水单-->

                <z-collapse v-if="v.loanStatus!=1010 && (v.cicCtbFileList && v.cicCtbFileList.length>0)" :title="$t('loan.paymentInfo')" class="divider mb_20">
                  <!--                <h3>{{$t('loan.paymentInfo')}}</h3>-->
                  <ul class="c-list basic-list border mt_15 ">
                    <li style="width:50%"><span class="tit">{{ $t('loan.refundAmount') }}：</span><div class="msg">{{ v.repaymentCurrency }} {{ v.repaymentAmount | formatNum }}</div></li><!--还款金额-->
                    <li style="width:50%"><span class="tit">{{ $t('loan.repaymentDate') }}：</span><div class="msg">{{ v.repaymentTime | dateConvert }}</div></li><!--还款日期-->
                    <li class="w-100"><span class="tit">{{ $t('loan.refundFile') }}：</span> <!--还款文件-->
                      <div v-if="v.cicCtbFileList && v.cicCtbFileList.length>0" class="msg c-file-list">
                        <a v-for="(fileObj,fileIndex) in v.cicCtbFileList" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)"><i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}</a>
                        <!--                      <i class="file-icon" :class="getFileType(fileObj.fileName)"></i>-->
                      </div>
                    </li>
                  </ul>
                </z-collapse>
                <!--        还款信息-->

                <div v-if="checkBtnLimit(v.loanStatus) && checkBtnSome(v.loanStatus)" :id="'#anchorAction_'+i" class="limit-btn">
                  <p v-if="isRepulse(v.loanStatus)" class="centerBtn btn-blue" @click="openVerify('repulse', v.id, v.loanStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:0,scheduleStatus:0,dataType:v.payFsType})">{{ $t('btns.repulse') }}</p>   <!-- 打回 -->
                  <p v-if="isRefuseLend(v.loanStatus)" class="centerBtn btn-blue" @click="openVerify('refuse', v.id, v.loanStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:0,scheduleStatus:0,dataType:v.payFsType})">{{ $t('btns.refuseLend') }}</p>   <!-- 拒绝放款 -->
                  <p v-if="isPass(v.loanStatus)" class="centerBtn btn-blue" @click="openVerify('pass', v.id, v.loanStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:0,scheduleStatus:0,dataType:v.payFsType})">{{ $t('btns.pass') }}</p>   <!-- 通过 -->
                  <p v-if="isSubmit(v.loanStatus)" class="centerBtn btn-blue" @click="openConfirm('submit', v.id, v.loanStatus,i,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:0,scheduleStatus:0,dataType:v.payFsType})">{{ $t('btns.submit') }}</p>   <!-- 提交 -->
                </div>
                <!--    底部按钮操作  :id="'#anchorAction_'+index"-->
                <invoice-transfer v-show="v.loanStatus === 1006" ref="invoiceMsgOut"/>
                <template v-if="v.cicFsScheduleVOS">
                  <div v-for="(item,index) in v.cicFsScheduleVOS.filter(s=>s.isSupplyShip==1&&s.supplyShipStatus>0)" :key="index" >
                    <div :id="'#anchorShip_'+i+index"/>
                    <z-collapse :title="$t('newrisk.s_ship_data')+ item.serialNumber " :is-toggle="true">
                      <template v-slot:action>
                        <p v-if="item.imo" class="btn-blue" @click="viewShipMsg(item)">{{ $t('btns.viewShipMsg') }}</p>   <!-- 查看船运信息 -->
                      </template>
                      <div v-for="(dtlItem, dtlIndex) in item.cicFsCreditDetailVOList" :key="dtlIndex+'ship'" class="c-list-bg mb_20">
                        <h3>{{ zmaType[dtlItem.type] }}</h3>
                        <ul class="c-list basic-list">
                          <li><span class="tit">{{ $t('loan.shipsName') }}：</span><div class="msg">{{ dtlItem.shipName }} {{ item.imo ? '('+ item.imo + ')': '' }}</div></li>
                          <!--            船名-->
                          <li><span class="tit">{{ $t('loan.shipmentDate') }}：</span><div class="msg">{{ dtlItem.shipTime | dateConvert }}</div></li>
                          <!--            装船日期-->
                          <li><span class="tit">{{ $t('loan.shipmentNumber') }}：</span><div class="msg">{{ dtlItem.shipNum | formatNum }} {{ dtlItem.shipNumUnit }}</div></li>
                          <!--            装船数量-->
                          <li><span class="tit">{{ $t('loan.dischargeDate') }}：</span><div class="msg">{{ dtlItem.breakBulkTime | dateConvert }}</div></li>
                          <!--            卸货日期-->
                          <li><span class="tit">{{ $t('loan.loadingPort') }}：</span><div class="msg">{{ dtlItem.loadPort }}</div></li>
                          <!--            装货港-->
                          <li><span class="tit">{{ $t('loan.dischargePort') }}：</span><div class="msg">{{ dtlItem.dischargePort }}</div></li>
                          <!--            卸货港-->
                          <li><span class="tit">{{ $t('loan.originArea') }}：</span><div class="msg">{{ dtlItem.countryOfOrigin }}</div></li>
                          <!--            原产地\地区-->
                          <li><span class="tit">{{ $t('loan.finalInvoiceNumber') }}：</span><div class="msg">{{ dtlItem.finalReceiptNum }}</div></li>
                          <!--            最终发票号-->

                          <li><span class="tit">{{ $t('loan.finalUnitPrice') }}：</span><div class="msg">{{ dtlItem.finalSettlePrice | formatNum }} {{ dtlItem.finalSettleCurrency }}/{{ dtlItem.finalSettleUnit }}</div></li>
                          <!--            最终结算单价-->
                          <li><span class="tit">{{ $t('loan.finalAmount') }}：</span><div class="msg">{{ dtlItem.finalCurrency }} {{ dtlItem.finalMoney | formatNum }}</div></li>
                          <!--            最终金额-->
                          <li><span class="tit">{{ $t('loan.amountAfterDeposit') }}：</span><div class="msg">{{ dtlItem.deductCurrency }} {{ dtlItem.deductMoney | formatNum }}</div></li>
                          <!--            扣除定金后金额-->
                          <li><span class="tit">{{ $t('loan.paymentDate') }}：</span><div class="msg">{{ dtlItem.rpaymentTime | dateConvert }}</div></li>
                          <!--            付款日期-->
                          <li v-if="dtlItem.remark" class="w-100"><span class="tit">{{ $t('loan.remark') }}：</span><div class="msg">{{ dtlItem.remark }}</div></li>
                          <!--            备注-->
                          <li class="w-100"><span class="tit">{{ $t('loan.fileUpload') }}：</span><div v-if="dtlItem.cicFsCtbFileVOS && dtlItem.cicFsCtbFileVOS.length >0" class="msg c-file-list">
                            <a v-for="(fileObj,fileIndex) in dtlItem.cicFsCtbFileVOS" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                              <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                            </a>
                          </div></li>
                        <!--            文件上传-->
                        </ul>
                      </div>
                    <!--     船期   采购信息、销售信息-->

                    </z-collapse>
                    <div v-if="checkBtnLimit(item.supplyShipStatus) && checkBtnSome(item.supplyShipStatus)" :id="'#anchorAction_'+index" class="limit-btn">
                      <p v-if="isRepulse(item.supplyShipStatus)" class="centerBtn btn-blue" @click="openVerify('repulse', v.id, item.supplyShipStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:item.id,scheduleStatus:item.supplyShipStatus,dataType:v.payFsType})">{{ $t('btns.repulse') }}</p>   <!-- 打回 -->
                      <p v-if="isPass(item.supplyShipStatus)" class="centerBtn btn-blue" @click="openVerify('pass', v.id, item.supplyShipStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:item.id,scheduleStatus:item.supplyShipStatus,dataType:v.payFsType})">{{ $t('btns.pass') }}</p>   <!-- 通过 -->
                    </div>
                  </div>
                </template>
                <!-- 补充船期 -->
              </template>
              <template v-if="loanType!=1&&v.cicFsScheduleVOS">
                <div v-for="(item,index) in v.cicFsScheduleVOS.filter(s=>s.isSupplyShip==0)" :id="'#anchorShip1_'+i+index" :key="index" >
                  <template v-if="item.reviewStatus >= 102">
                    <!-- <span onselectstart="return false" @click="loanToggle(item)"><i :class="item.show ? 'el-icon-arrow-up': 'el-icon-arrow-down'" class="iconfont"/></span> -->
                    <h3 v-if="loanType!=2" :id="'#anchor1_'+index" class="loan-tit">{{ 'NO.'+ item.serialNumber+' ' +$t('newrisk.r_financing') }} </h3>
                    <!--            {{zmaShow[index] ? $t('loan.pickUp'):$t('loan.spread')}} 展开/收起 文字去掉-->
                    <div v-show="item.show">
                      <p class="zma-status">
                        <span v-if="item.reviewStatus === 105" class="cur">A. {{ $t('allorders_status.105') }}</span>
                        <span v-for="(subItem,subIndex) in zmaStatusList" v-else :class="getCurStatus(item.reviewStatus) === subIndex?'cur':''" :key="subIndex">{{ subItem }}</span>
                      </p>
                      <z-collapse v-if="item.zmaAuditLogs.length > 0" :title="'NO.'+ item.serialNumber +' ' + $t('loan.loanAuditRecord')" :is-toggle="true" :is-hide="false">
                        <el-table :data="item.zmaAuditLogs.slice((pagingParm.pageNo-1)*pageSize, pagingParm.pageNo*pageSize)" class="dtl-tb">
                          <el-table-column :label="$t('loan.auditConclusion')" prop="auditOpinion" width="700"/>
                          <el-table-column :label="$t('loan.auditName')" prop="auditName" width="140"/>
                          <el-table-column :label="$t('loan.date')" width="180">
                            <template slot-scope="scope">{{ scope.row.createTime | dateTimeConvert }}</template>
                          </el-table-column>
                        </el-table>
                        <el-pagination
                          v-show="item.zmaAuditLogs.length>5"
                          :total="item.zmaAuditLogs.length"
                          :page-size="pageSize"
                          :current-page.sync="pagingParm.pageNo"
                          class="page-theme text-center pb_25"
                          background
                          layout="prev, pager, next"/>
                      </z-collapse>
                      <!--      NO.1 放款审核记录-->

                      <div :id="getCurStatus(item.reviewStatus) === 0 ? '#anchorAction_'+index :''"/>
                      <z-collapse v-if="item.cicFsDepositInfoList && item.cicFsDepositInfoList.length > 0" :title="$t('loan.depositInfo')" :is-toggle="true">
                        <div class="card-box">
                          <div v-for="(subItem,subIndex) in item.cicFsDepositInfoList" :key="subIndex" class="single-card">
                            <z-card :title="applyStatus[subItem.depositType]">
                              <ul v-if="subItem.depositType==2" class="card-list">
                                <div class="type">{{ subItem.contractType?$t('newrisk.deposit_row_8'):$t('forfait.deposit_1') }}</div>
                                <template v-if="subItem.contractType">
                                  <li><span class="tit">{{ $t('loan.depositAttr') }}</span><div class="msg">{{ subItem.depositAtt == 2 ? $t('loan.depositAttr2'):$t('loan.depositAttr1') }}</div></li>
                                  <li><span class="tit">{{ $t('newrisk.deposit_row_2') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                                  <li><span class="tit">{{ $t('newrisk.deposit_row_3') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                                  <li><span class="tit">{{ $t('newrisk.deposit_row_5') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                                  <li><span class="tit" >{{ $t('newrisk.deposit_row_7') }}</span><div class="msg">{{ subItem.lssuing }}</div></li> <!--开证行-->
                                  <li><span class="tit">{{ $t('loan.fileUpload') }}</span>
                                    <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                                      <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                        <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                                      </a>
                                    </div>
                                  </li>
                                </template>
                                <template v-else>
                                  <li><span class="tit">{{ $t('loan.depositAttr') }}</span><div class="msg">{{ subItem.depositAtt == 2 ? $t('loan.depositAttr2'):$t('loan.depositAttr1') }}</div></li>
                                  <li><span class="tit">{{ $t('loan.depositAmount') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                                  <li><span class="tit">{{ $t('loan.invoiceNo') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                                  <li><span class="tit">{{ $t('loan.depositIDate') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                                  <li><span class="tit">{{ $t('loan.fileUpload') }}</span>
                                    <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                                      <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                        <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                                      </a>
                                    </div>
                                  </li>
                                </template>
                              </ul>
                              <ul v-else class="card-list">
                                <li><span class="tit">{{ $t('loan.depositAttr') }}</span><div class="msg">{{ subItem.depositAtt == 2 ? $t('loan.depositAttr2'):$t('loan.depositAttr1') }}</div></li>
                                <li><span class="tit">{{ $t('loan.depositAmount') }}</span><div class="msg">{{ subItem.depositCurrency }} {{ subItem.deposit | formatNum }}</div></li> <!--定金金额-->
                                <li><span class="tit">{{ $t('loan.invoiceNo') }}</span><div class="msg">{{ subItem.invoiceNumber }}</div></li> <!--发票号-->
                                <li><span class="tit">{{ $t('loan.depositIDate') }}</span><div class="msg">{{ subItem.paymentDate | dateConvert }}</div></li> <!--定金付款日-->
                                <li><span class="tit">{{ $t('loan.fileUpload') }}</span>
                                  <div v-if="subItem.fileArrVos && subItem.fileArrVos.length>0" class="msg c-file-list">
                                    <a v-for="(fileObj,fileIndex) in subItem.fileArrVos" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                      <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                                    </a>
                                  </div>
                                </li>
                                <!--文件上传-->
                              </ul>
                            </z-card>
                          </div>
                          <!--采购合同、销售合同、终端合同-->

                        </div>
                      </z-collapse>
                      <!--    定金资料-->

                      <z-collapse :title="'NO.'+ item.serialNumber +' ' + $t('loan.lending')" :is-toggle="true">
                        <template v-slot:action>
                          <p v-if="item.imo" class="btn-blue" @click="viewShipMsg(item)">{{ $t('btns.viewShipMsg') }}</p>   <!-- 查看船运信息 -->
                        </template>

                        <div v-for="(dtlItem, dtlIndex) in item.cicFsCreditDetailVOList" :key="dtlIndex" class="c-list-bg mb_20">
                          <h3>{{ zmaType[dtlItem.type] }}</h3>
                          <ul class="c-list basic-list">
                            <li><span class="tit">{{ $t('loan.shipsName') }}：</span><div class="msg">{{ dtlItem.shipName }} {{ item.imo ? '('+ item.imo + ')': '' }}</div></li>
                            <!--            船名-->
                            <li><span class="tit">{{ $t('loan.shipmentDate') }}：</span><div class="msg">{{ dtlItem.shipTime | dateConvert }}</div></li>
                            <!--            装船日期-->
                            <li><span class="tit">{{ $t('loan.shipmentNumber') }}：</span><div class="msg">{{ dtlItem.shipNum | formatNum }} {{ dtlItem.shipNumUnit }}</div></li>
                            <!--            装船数量-->
                            <li><span class="tit">{{ $t('loan.dischargeDate') }}：</span><div class="msg">{{ dtlItem.breakBulkTime | dateConvert }}</div></li>
                            <!--            卸货日期-->
                            <li><span class="tit">{{ $t('loan.loadingPort') }}：</span><div class="msg">{{ dtlItem.loadPort }}</div></li>
                            <!--            装货港-->
                            <li><span class="tit">{{ $t('loan.dischargePort') }}：</span><div class="msg">{{ dtlItem.dischargePort }}</div></li>
                            <!--            卸货港-->
                            <li><span class="tit">{{ $t('loan.originArea') }}：</span><div class="msg">{{ dtlItem.countryOfOrigin }}</div></li>
                            <!--            原产地\地区-->
                            <li><span class="tit">{{ $t('loan.finalInvoiceNumber') }}：</span><div class="msg">{{ dtlItem.finalReceiptNum }}</div></li>
                            <!--            最终发票号-->

                            <li><span class="tit">{{ $t('loan.finalUnitPrice') }}：</span><div class="msg">{{ dtlItem.finalSettlePrice | formatNum }} {{ dtlItem.finalSettleCurrency }}/{{ dtlItem.finalSettleUnit }}</div></li>
                            <!--            最终结算单价-->
                            <li><span class="tit">{{ $t('loan.finalAmount') }}：</span><div class="msg">{{ dtlItem.finalCurrency }} {{ dtlItem.finalMoney | formatNum }}</div></li>
                            <!--            最终金额-->
                            <li><span class="tit">{{ $t('loan.amountAfterDeposit') }}：</span><div class="msg">{{ dtlItem.deductCurrency }} {{ dtlItem.deductMoney | formatNum }}</div></li>
                            <!--            扣除定金后金额-->
                            <li><span class="tit">{{ $t('loan.paymentDate') }}：</span><div class="msg">{{ dtlItem.rpaymentTime | dateConvert }}</div></li>
                            <!--            付款日期-->
                            <li v-if="dtlItem.remark" class="w-100"><span class="tit">{{ $t('loan.remark') }}：</span><div class="msg">{{ dtlItem.remark }}</div></li>
                            <!--            备注-->
                            <li class="w-100"><span class="tit">{{ $t('loan.fileUpload') }}：</span><div v-if="dtlItem.cicFsCtbFileVOS && dtlItem.cicFsCtbFileVOS.length >0" class="msg c-file-list">
                              <a v-for="(fileObj,fileIndex) in dtlItem.cicFsCtbFileVOS" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                                <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                              </a>
                            </div></li>
                            <!--            文件上传-->
                          </ul>
                        </div>
                        <!--     船期   采购信息、销售信息-->

                      </z-collapse>
                      <!--      NO.1放款-->

                      <div :id="getCurStatus(item.reviewStatus) === 1 ? '#anchorAction_'+index :''"/>
                      <forfait-msg :ref="'forfaitMsg'+i+index" @submit="forfaitSubmit"/>
                      <!--      福费廷协议  -->

                      <z-collapse v-if="item.zmaWaterFileS && item.zmaWaterFileS.length>0&&item.reviewStatus!=111&&item.reviewStatus!=112&&item.reviewStatus!=113" :title="$t('loan.loanWater')" :is-toggle="true" class="divider mb_20">
                        <ul class="c-list border mt_15">
                          <li class="w-100"><span class="tit">{{ $t('loan.fileUpload') }}：</span><div class="msg c-file-list">
                            <a v-for="(fileObj,fileIndex) in item.zmaWaterFileS" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)">
                              <i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}
                            </a>
                          </div></li>
                        </ul>
                      </z-collapse>
                      <!--       放款水单-->
                      <div :id="'#anchorAction_'+index "/>
                      <z-collapse v-if="item.reviewStatus!=130 && (item.cicCtbFileList && item.cicCtbFileList.length>0)" :title="$t('loan.paymentInfo')" class="divider mb_20">
                        <!--                <h3>{{$t('loan.paymentInfo')}}</h3>-->
                        <ul class="c-list basic-list border mt_15 ">
                          <li style="width:50%"><span class="tit">{{ $t('loan.refundAmount') }}：</span><div class="msg">{{ item.shipRepaymentAmountUnit }} {{ item.shipRepaymentAmount | formatNum }}</div></li><!--还款金额-->
                          <li style="width:50%"><span class="tit">{{ $t('loan.repaymentDate') }}：</span><div class="msg">{{ item.repaymentTime | dateConvert }}</div></li><!--还款日期-->
                          <li class="w-100"><span class="tit">{{ $t('loan.refundFile') }}：</span> <!--还款文件-->
                            <div v-if="item.cicCtbFileList && item.cicCtbFileList.length>0" class="msg c-file-list">
                              <a v-for="(fileObj,fileIndex) in item.cicCtbFileList" :key="fileIndex" :href="zmaDownloadFile(fileObj.fileCode)"><i :class="getFileType(fileObj.fileName)" class="file-icon"/>{{ fileObj.fileName }}</a>
                              <!--                      <i class="file-icon" :class="getFileType(fileObj.fileName)"></i>-->
                            </div>
                          </li>
                        </ul>
                      </z-collapse>
                      <!--        还款信息-->

                      <div v-if="v.cicFsScheduleVOS && v.cicFsScheduleVOS.length > 0 && checkBtnLimit(item.applicationStatus) && checkBtnSome(item.applicationStatus)" :id="'#anchorAction1_'+i+index" class="limit-btn">
                        <p v-if="isRepulse(item.applicationStatus)" class="centerBtn btn-blue" @click="openVerify('repulse', item.id, item.applicationStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:item.id,scheduleStatus:item.applicationStatus,dataType:v.payFsType,dataType:v.payFsType })">{{ $t('btns.repulse') }}</p>   <!-- 打回 -->
                        <p v-if="isRefuseLend(item.applicationStatus)" class="centerBtn btn-blue" @click="openVerify('refuse', item.id, item.applicationStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:item.id,scheduleStatus:item.applicationStatus,dataType:v.payFsType,dataType:v.payFsType })">{{ $t('btns.refuseLend') }}</p>   <!-- 拒绝放款 -->
                        <p v-if="isPass(item.applicationStatus)" class="centerBtn btn-blue" @click="openVerify('pass', item.id, item.applicationStatus,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:item.id,scheduleStatus:item.applicationStatus,dataType:v.payFsType,dataType:v.payFsType })">{{ $t('btns.pass') }}</p>   <!-- 通过 -->
                        <p v-if="isSubmit(item.applicationStatus)" class="centerBtn btn-blue" @click="openConfirm('submit', item.id, item.applicationStatus,'forfaitMsg'+i+index,{mainLoanId:v.id,loanStatus:v.loanStatus,scheduleId:item.id,scheduleStatus:item.applicationStatus,dataType:v.payFsType,dataType:v.payFsType })">{{ $t('btns.submit') }}</p>   <!-- 提交 -->
                      </div>
                      <!--    底部按钮操作  :id="'#anchorAction_'+index"-->

                      <invoice-transfer v-show="item.applicationStatus === 108" :ref="'invoiceMsg'+i+index"/>
                      <!--       v-show="item.cicFsCreditInvoiceInfoVO"      发票转让-->
                    </div>
                  </template>

                </div>
              </template>

            </div>
          </div>

          <!-- 审核弹出层 -->
          <VerifyPopup
            v-if="isVerifyShow"
            :title="verifyTitle"
            :placeholder="$t('financingFundDetail.verifyPopupPlaceholder')"
            maxlength="300"
            @cancel="isVerifyShow = false"
            @confirm="verifyOk"
          />
          <ConfirmPopup v-if="isConfirmShow" :title="confirmTitle" @cancel="isConfirmShow=false" @confirm="confirmOk"/>
        </div>

        <!--    融资合同-->
        <finance-info v-show="index===1" ref="financeInfo" @update="getDetail"/>

        <!--    申请基本信息-->
        <base-info v-if="index===2" :base-data-one="baseDataOne" :base-data-finance="baseDataFinance" :base-data-two="baseDataTwo"/>

      </div>
    </div>

    <ul v-if="index===0 && zmaCredit && zmaCredit.length > 0" class="fixed-loan">
      <!-- v-if="hideStatus.indexOf(item.applicationStatus)<0" -->

      <div v-for="(item,index) in zmaCredit.filter(s=>s.loanStatus!=100&&s.loanStatus!=101&&s.loanStatus!=1001&&s.loanStatus!=1002)" :key="index" >
        <template v-if="item.payFsType!=2">
          <li >
            <a v-if="checkBtnSome(item.loanStatus)&&checkBtnLimit(item.loanStatus)" class="action" @click="goAnchor('#anchorAction_'+index,item)">{{ isSubmit(item.loanStatus) ? $t('btns.ope'):$t('btns.approval') }}</a>
            <a @click="goAnchor('#anchor_'+index,item)">NO.{{ item.serialNumber+' ' + [$t('newrisk.p_financing'),$t('newrisk.r_financing'),$t('newrisk.pr_financing')][loanType-1] }}</a>
          </li>
          <!-- 补充船期 -->
          <template v-if="item.cicFsScheduleVOS">
            <li v-for="(v,i) in item.cicFsScheduleVOS.filter(s=>s.isSupplyShip==1&&s.supplyShipStatus>0)" :key="i">
              <a style="background-color: #fff;color:#7996F5;" @click="goAnchor('#anchorShip_'+index+i,item)">{{ $t('newrisk.s_ship_data')+' ' + v.serialNumber }}</a>
            </li>
          </template>
          <!-- 预付款下的应收账款融资 -->
          <template v-if="item.cicFsScheduleVOS&&item.payFsType ==3">
            <template v-for="(v,i) in item.cicFsScheduleVOS.filter(s=>s.isSupplyShip==0)">
              <li v-if="v.reviewStatus >= 102" :key="i">
                <a v-if="checkBtnSome(v.reviewStatus)&&checkBtnLimit(v.reviewStatus)" class="action" @click="goAnchor('#anchorAction1_'+index+i,item)">{{ isSubmit(v.reviewStatus) ? $t('btns.ope'):$t('btns.approval') }}</a>
                <a style="background-color: #fff;color:#7996F5;" @click="goAnchor('#anchorShip1_'+index+i,item)">{{ $t('newrisk.r_financing')+' ' + v.serialNumber }}</a>
              </li>
            </template>
          </template>
        </template>
        <!-- 应收账款融资 -->
        <template v-else>
          <template v-for="(v,i) in item.cicFsScheduleVOS.filter(s=>s.isSupplyShip==0)">
            <li v-if="v.reviewStatus >= 102" :key="i">
              <a v-if="checkBtnSome(v.reviewStatus)&&checkBtnLimit(v.reviewStatus)" class="action" @click="goAnchor('#anchorAction1_'+index+i,item)">{{ isSubmit(v.reviewStatus) ? $t('btns.ope'):$t('btns.approval') }}</a>
              <a @click="goAnchor('#anchor_'+index,item)">{{ $t('newrisk.r_financing')+' ' + v.serialNumber }}</a>
            </li>
          </template>
        </template>
      </div>

    </ul>
  </div>
</template>

<script>
import index from './loanDetail'
export default index
</script>
<style lang="scss" scoped>
  .loan-detail{
    .loan-list{
      padding-top: 10px;
      padding-bottom: 10px;
    }
    .loan-tit{
      height: 35px;
      box-sizing: border-box;
      padding: 5px 10px;
      text-align: center;
      line-height: 25px;
      font-size: 16px;
      color: #FFFFFF;
      background: #7996F5;
      box-shadow: 0 0 10px 0 rgba(0,0,0,0.10);
      border-radius: 4px 4px 0 0;
      font-weight: normal;
      position: relative;
      span{
        position: absolute;
        right: 18px;
        top: 6px;
        font-size: 14px;
        color: #FAFAFA;
        &:hover{
          cursor: pointer;
        }
      }
      .iconfont{
        font-size: 18px;
        font-weight: bold;
        color: #ffffff;
        margin-left: 5px;
      }
    }

    .coll-box + .coll-box{
      border-top: 20px solid #F5F6F8;
    }

    .limit-btn{
      border-top: 1px solid #EAEAEA;
      text-align: center;
      margin-top:20px;
    }

    .c-list.edit{
      .msg{
        width: 520px;
      }
    }
    .card-box{
      padding: 9px 0 19px;
      display: flex;
      justify-content: flex-start;
      width: 100%;
      overflow: hidden;
      .single-card + .single-card{
        margin-left: 15px;
      }
      .card-item{
        width: 330px;
      }
    }
    .basic-list{
      display: flex;
      flex-wrap: wrap;
      li{
        width: 495px;
        &.w-100{
          width:100%
        }
      }
    }
    .zma-status{
      padding: 20px 0 10px;
      span{
        font-size: 14px;
        color: #81899E;
        line-height: 20px;
        &+span{
          margin-left: 40px;
        }
        &.cur{
          color: #7996F5;
        }
      }
    }

    .fixed-loan{
      position: fixed;
      right: 10px;
      top: 50%;
      transform: translateY(-50%);
      z-index: 9;

      li{
        display: flex;
        justify-content: flex-end;
        margin-bottom: 4px;

        a{
          // width: 48px;
          height: 48px;
          background-color: #7996F5;
          box-shadow: 0 0 10px 0 rgba(0,0,0,0.10);
          text-align: center;
          box-sizing: border-box;
          line-height: 30px;
          padding: 10px 10px;
          color: #ffffff;
          border-radius: 4px;
          display: inline-block;
          font-size: 14px;
          margin-left: 4px;
          &.action{
            box-sizing: border-box;
            background: #FFFFFF;
            color: #7996F5;
            width: 0;
            opacity: 0;
            white-space: nowrap;
            overflow: hidden;
            transition: all 0.5s;
          }
          &:hover{
            cursor: pointer;
          }
        }
        &:hover{
          a.action{
            opacity: 1;
            width: 70px;
            padding: 10px;
          }
        }
      }
    }
  }
  .card-list {
    position: relative;
    .type{
      position: absolute;
      top: -28px;
      right: 0;
      font-size: 14px;
      color: #666666;
    }
  }
</style>
